import * as Yup from 'yup';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import 'react-dropzone-uploader/dist/styles.css';
// components
import { FormProvider, RHFCheckbox, RHFTextField } from '../../../components/hook-form';
import tracker from '../../../api/tracker';
import RHFFileInput from '../../../components/hook-form/RHFFileInput';
import Label from '../../../components/Label';
// utils
import { compressImage } from '../../../utils/imageCompression';
// ----------------------------------------------------------------------

export default function CollaboratorForm({ collaborator }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (collaborator) {
      const fields = ['name', 'description', 'active'];
      fields.forEach((field) => setValue(field, collaborator[field]));
    }
  }, [collaborator]);

  const EventSchema = Yup.object().shape({
    name: Yup.string().required(t('Required')),
    description: Yup.string().required('Required'),
  });

  const defaultValues = {
    name: '',
    description: '',
    date: '',
    image: null,
    active: true,
  };

  const methods = useForm({
    resolver: yupResolver(EventSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    if (data.image && data.image[0]) {
      try {
        const compressedImage = await compressImage(data.image[0], {
          maxSizeMB: 5,
          maxWidthOrHeight: 1920,
        });
        data.image = compressedImage;
      } catch (error) {
        console.error('Error compressing image:', error);
        return;
      }
    }

    try {
      if (!collaborator) {
        await tracker.post('collaborators', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        await tracker.post(`collaborators/update/${collaborator.hashid}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      navigate('/dashboard/collaborators', { replace: true });
    } catch (error) {
      console.error('Error submitting collaborator:', error.response?.data || error.message);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <RHFTextField name="name" label={t('Name')} />
        </Stack>
        <RHFTextField name="description" label={t('Description')} />

        <div style={{ marginTop: '80px' }}>
          <Label>{t('Imagen')}</Label>
          <RHFFileInput name="image" fileUrl={collaborator && collaborator.image ? collaborator.image : null} />
        </div>
        <RHFCheckbox name="active" label="Activo" value={collaborator ? collaborator.active : true} />
        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          {collaborator ? t('Save') : t('Create')}
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
